"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPortForName = exports.defaults = void 0;
exports.defaults = {
    api: {
        auth: {
            port: 3001,
        },
        editorialDesk: {
            port: 3002,
        },
        mdlinxMain: {
            port: 3003,
        },
    },
};
var defaultPortForName = function (name) {
    switch (name) {
        case 'auth-api':
            return exports.defaults.api.auth.port;
        case 'editorial-desk-api':
            return exports.defaults.api.editorialDesk.port;
        case 'mdlinx-main':
            return exports.defaults.api.mdlinxMain.port;
        default:
            throw new Error("Unknown server name: ".concat(name));
    }
};
exports.defaultPortForName = defaultPortForName;
//# sourceMappingURL=defaults.js.map